module.exports = __webpack_public_path__ + "static/media/LogoAssemini.7ac52e28.png";